<template>
  <v-tooltip bottom>
    <template #activator="{ on }">
      <v-icon small class="mav-badge ml-2" :aria-label="label" v-on="on">mdi-robot</v-icon>
    </template>
    <span>{{ label }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'MavBadge',
  props: {
    label: {
      type: String,
      default: 'Created via MAV',
    },
    color: {
      type: String,
      default: 'purple',
    },
  },
};
</script>

<style scoped>
.mav-badge {
  background: transparent !important;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.4) !important;
  color: white !important;
  transition: all 0.3s ease !important;
}

.mav-badge:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.6) !important;
  transform: scale(1.1);
}
</style>
